import * as React from 'react';
import { useFormState } from 'react-use-form-state';
import cls from 'classnames';

import { SSOButtons } from 'src/explore/compositions/SSOButtons';
import { ErrorBox } from 'src/explore/elements/bs4/ErrorBox';
import { FormStateInput } from 'src/explore/elements/FormStateInput';
import { LoadingButton } from 'src/shoppe/elements/LoadingButton';

import { Agreement } from './elements/Agreement';

type ISignupField = {
  confirmation: string;
  email: string;
  password: string;
};

interface Props {
  defaultEmail: string;
  loading: boolean;
  signUpError?: string[];
  switchMode: ( mode: string ) => void;
  onSubmit: ( form: any ) => void;
}

export const Signup: React.FC<Props> = ({
  defaultEmail,
  loading,
  signUpError,
  switchMode,
  onSubmit,
}) => {
  const emailRef = React.useRef<HTMLInputElement>( null );

  const [ formState, { email, password }] = useFormState<ISignupField>({
    email: defaultEmail,
  });

  React.useEffect(() => {
    emailRef.current?.focus();
  }, []);

  const handleSubmit = ( event: React.FormEvent ) => {
    event.preventDefault();

    onSubmit( formState );
  };

  return (
    <>
      <form className="spec__signup-form" onSubmit={handleSubmit}>
        {!!signUpError && (
          <div className="row mb-4">
            <div className="col-12">
              <ErrorBox className="" errors={signUpError} />
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-12 form-group pb-0">
            <FormStateInput
              {...email( 'email' )}
              className={cls( signUpError?.length && 'border-danger', 'fs-5' )}
              aria-label="Email Address"
              placeholder="Email Address"
              ref={emailRef}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group pb-0">
            <FormStateInput
              {...password( 'password' )}
              className={cls( signUpError?.length && 'border-danger', 'fs-5' )}
              minLength={6}
              aria-label="Password"
              placeholder="Password"
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group pb-0">
            <FormStateInput
              {...password( 'confirmation' )}
              className={cls( signUpError?.length && 'border-danger', 'fs-5' )}
              aria-label="Confirm Password"
              placeholder="Confirm Password"
              required
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6 form-group mt-2">
            <button
              type="button"
              className="btn btn-block py-3 font-weight-bold text-secondary"
              onClick={() => switchMode( 'login' )}
            >
              Sign In Instead
            </button>
          </div>
          <div className="col-6 form-group mt-2">
            <LoadingButton
              className="btn btn-block py-3 font-weight-bold btn-secondary"
              disabled={Object.keys( formState.values ).some(
                ( value: string ) => !formState.validity[value as keyof ISignupField]
              )}
              loading={loading}
              type="submit"
            >
              <span className="d-sm-none">Next</span>
              <span className="d-none d-sm-inline">Save & Continue</span>
            </LoadingButton>
          </div>
        </div>
      </form>
      <SSOButtons />
      <Agreement />
    </>
  );
};
